function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-pills",
  "data-name": "Icon awesome-pills",
  d: "M7.875,2.25A7.871,7.871,0,0,0,0,10.125v15.75a7.875,7.875,0,0,0,15.75,0V10.125A7.871,7.871,0,0,0,7.875,2.25ZM11.25,18H4.5V10.125a3.375,3.375,0,0,1,6.75,0Zm9.823-2.088a.578.578,0,0,0-.865.056A11.184,11.184,0,0,0,35.838,31.6a.572.572,0,0,0,.056-.865ZM37.23,14.576a11.21,11.21,0,0,0-14.513-1.118.572.572,0,0,0-.056.865L37.484,29.145a.578.578,0,0,0,.865-.056A11.2,11.2,0,0,0,37.23,14.576Z",
  transform: "translate(0 -2.25)",
  fill: "#1aa0e0"
});

function SvgIconPill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.499,
    height: 31.5,
    viewBox: "0 0 40.499 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPill);
export default __webpack_public_path__ + "static/media/icon-pill.f160ba87.svg";
export { ForwardRef as ReactComponent };